// Mock data for FltrLnk landing page

export const features = [
  {
    id: 1,
    title: "Fltr Screen",
    description: "Search, Swipe, and Fltr through users to find your perfect LNK. Discover connections that matter easily with our innovative swipe screen allowing user to quickly access others users through different algorithms by category, location, or key word search.",
    placeholder: "Swipe Interface",
    imageUrl: "https://customer-assets.emergentagent.com/job_68d28ed4-bc93-4225-90c1-ea1c40af32dc/artifacts/as6pajo5_gg.jpg"
  },
  {
    id: 2,
    title: "Fltr Screen Mini Profile",
    description: "Access user content and points of communication in one place. Connect and engage seamlessly with users through chats and other links to social contacts, as well as take a deeper dive into their profile through their Lifestyle Passions and Attributes, then view their digital content in their Gallery.",
    placeholder: "Mini Profile View",
    imageUrl: "https://customer-assets.emergentagent.com/job_68d28ed4-bc93-4225-90c1-ea1c40af32dc/artifacts/ph4anwvv_IMG_2382.jpeg"
  },
  {
    id: 3,
    title: "FltrRadar",
    description: "Access a GPS Map to discover all things around you and explore different areas through searches and Fltrs. Find people, businesses, and opportunities anywhere at anytime with searches and Fltr category algorithms that include an array of user types and niches.",
    placeholder: "GPS Map View",
    imageUrl: "https://customer-assets.emergentagent.com/job_68d28ed4-bc93-4225-90c1-ea1c40af32dc/artifacts/3gpsxfq2_IMG_2403.jpeg"
  },
  {
    id: 4,
    title: "FltrRadar Mini Profile",
    description: "Access a deeper look into Businesses profiles through the FltrRadar Mini Profile, allowing you to gain more information about the business such as hours of operation, their business address, and more.",
    placeholder: "Business Profile",
    imageUrl: "https://customer-assets.emergentagent.com/job_3b5ca5ac-4a5a-4d76-aad1-9c866f3c25e6/artifacts/r52bv0j3_IMG_2569.jpeg"
  },
  {
    id: 5,
    title: "Stay Connected",
    description: "Keep track for user communication and interactions all in one organized and accessible place.",
    placeholder: "Chat List",
    imageUrl: "https://customer-assets.emergentagent.com/job_fltr-discovery/artifacts/p3ilxfd9_unnamed%20%286%29.jpg"
  },
  {
    id: 6,
    title: "FltrHub",
    description: "Your central hub for managing all FltrLnk premium features. Access and use all premium features in one place and subscribe to FltrLite.",
    placeholder: "Hub Dashboard",
    imageUrl: "https://customer-assets.emergentagent.com/job_fltr-discovery/artifacts/g07o5c40_Simulator%20Screenshot%20-%20iPhone%2016%20Pro%20Max%20-%202025-10-22%20at%2012.00.19.png"
  },
  {
    id: 7,
    title: "User Profile Screen",
    description: "Your home user screen where users can access all of your content, MOODZ posts, reposts, public favorites collections, as well as access your different gateways of social connections.",
    placeholder: "User Profile",
    imageUrl: "https://customer-assets.emergentagent.com/job_68d28ed4-bc93-4225-90c1-ea1c40af32dc/artifacts/g8i5dfsk_IMG_2381.jpeg"
  }
];

// Generate leaderboard data for Top LNK Challenge (100 entries, 10 pages)
export const generateTopLNKData = () => {
  const states = ['CA', 'TX', 'NY', 'FL', 'IL', 'PA', 'OH', 'GA', 'NC', 'MI', 'NJ', 'VA', 'WA', 'AZ', 'MA', 'TN', 'IN', 'MO', 'MD', 'WI', 'CO', 'MN', 'SC', 'AL', 'LA', 'KY', 'OR', 'OK', 'CT', 'UT'];
  const data = [];
  
  for (let i = 0; i < 100; i++) {
    data.push({
      rank: i + 1,
      state: states[Math.floor(Math.random() * states.length)],
      subscribers: Math.floor(Math.random() * 4000) + 1000,
      progress: Math.floor((Math.random() * 4000 + 1000) / 50) // Progress towards 5K
    });
  }
  
  // Sort by subscribers descending
  return data.sort((a, b) => b.subscribers - a.subscribers).map((item, index) => ({
    ...item,
    rank: index + 1
  }));
};

// Generate leaderboard data for Top Invite Challenge (100 entries, 10 pages)
export const generateTopInviteData = () => {
  const usernames = ['BusinessPro', 'LinkMaster', 'DiscoveryKing', 'RadarQueen', 'FltrChamp', 'ConnectGuru', 'SweepWinner', 'TopInviter', 'NetworkBoss', 'SocialStar'];
  const data = [];
  
  for (let i = 0; i < 100; i++) {
    data.push({
      rank: i + 1,
      username: `${usernames[Math.floor(Math.random() * usernames.length)]}${i + 1}`,
      invites: Math.floor(Math.random() * 500) + 50,
      progress: Math.floor((Math.random() * 500 + 50) / 50) // Progress percentage
    });
  }
  
  // Sort by invites descending
  return data.sort((a, b) => b.invites - a.invites).map((item, index) => ({
    ...item,
    rank: index + 1
  }));
};

export const topLNKData = generateTopLNKData();
export const topInviteData = generateTopInviteData();